export const retrieveProduct = product => {
    if (!product) {
        return null;
    }
    return {...product.attributes, id: product.id};
};